import React, { Component } from 'react';
import classNames from 'classnames';

import PropTypes from 'prop-types';

import { tickOptions } from '../../constants/chart-options';
import Axis from './axis';
import DotPlot from './dot-plot';
import Grid from './grid';
import Line from './line';
import * as chartUtils from '../../../utils/chart-utils';

class DotPlotChart extends Component{
    constructor( props ){
        super( props );
        const {
            data,
            height,
            margin,
            scales: { xScale, yScale },
            styles,
            width,
            yKey,
            xKey,
            interval
        } = this.props;

        this.state = {
            dotPlotProps: {
                data,
                keys: {
                    x: xKey,
                    y: yKey
                },
                styles,
                xScale,
                yScale
            },
            gridProps: {
                gridWidth: width,
                scale: yScale(),
                tickValues: this.generateYTicks(),
                type: 'horizontal',
            },
            lineProps: {
                data,
                keys: {
                    x: xKey,
                    y: yKey
                },
                styles,
                xScale,
                yScale
            },
            verticalGridProps: {
                gridHeight: height,
                scale: xScale(),
                tickValues: chartUtils.defaultDateTickValues( interval, data ),
                type: 'vertical',
            },
            yaxisProps: {
                classPrefix: 'left-',
                height: height,
                margin,
                scales: { yScale },
                tickFormat: this.tickFormat,
                tickValues: this.generateYTicks(),
                type: 'y',
                width: 0,
            },
        };
    }

    tickDateFormat = ( date, dateIndex ) => {
        const allDisplayedDates = chartUtils.defaultDateTickValues( this.props.interval, this.props.data );

        return chartUtils.getTimeFormat( allDisplayedDates, date, dateIndex, this.props.interval );
    }

    generateYTicks = () => {
        const { yScale } = this.props.scales;
        const yScaleDomain = yScale().domain();

        const step = ( yScaleDomain[1] - yScaleDomain[0] ) / tickOptions.Y_NUM_TICKS;

        // since generating ticks using d3 range is exclusive, we append the max to the array
        return [ ...chartUtils.getTickValues( 'range', yScaleDomain[0], yScaleDomain[1], step ), yScaleDomain[1] ];
    }

    tickFormat = ( number ) => chartUtils.getNumberFormat( number, '%' );

    render(){
        const { topOffset, height, margin, scales: { xScale },
            styles, width, interval, data } = this.props;
        const { yaxisProps, lineProps, gridProps, dotPlotProps, verticalGridProps } = this.state;
        const xAxisProps = {
            height: height,
            margin,
            scales: { xScale },
            tickFormat: this.tickDateFormat,
            tickValues: chartUtils.defaultDateTickValues( interval, data ),
            type: 'x',
            width
        };

        const dotPlotClass = classNames( {
            [styles.dotPlotLightBlue]: true,
        } );
        return (
            <g className={dotPlotClass} transform={`translate(0 ${topOffset})`}>
                <Axis {...yaxisProps} />
                <Axis {...xAxisProps} />
                <Grid {...gridProps} />
                <Grid {...verticalGridProps} />
                <DotPlot {...dotPlotProps} />
                <Line {...lineProps} />
            </g>
        );
    }
};

DotPlotChart.defaultProps = {
    data: [],
    interval: 'day',
    topOffset: 0,
};

DotPlotChart.propTypes = {
    data: PropTypes.array.isRequired,
    height: PropTypes.number.isRequired,
    interval: PropTypes.string,
    margin: PropTypes.object.isRequired,
    scales: PropTypes.shape( {
        xScale: PropTypes.func.isRequired,
        yScale: PropTypes.func.isRequired
    } ),
    styles: PropTypes.object,
    topOffset: PropTypes.number,
    width: PropTypes.number.isRequired,
    xKey: PropTypes.string.isRequired,
    yKey: PropTypes.string.isRequired,
};

export default DotPlotChart;
